import {NotificationService} from "../../services/NotificationService";
import {ScheduledMaintenanceModel} from "../../models/tasks/ScheduledMaintenanceModel";

export class ScheduledMaintenanceCtrl {
    $scope:any;
    gridOptions:any;
    maintenanceHistoryGridOptions:any;
    public static $inject = ['$scope','ScheduledMaintenanceModel','NotificationService'];
    constructor($scope:any, public model:ScheduledMaintenanceModel,public notifyService:NotificationService) {
        this.$scope = $scope;
        $scope.vm = this;
        this.getAssets();
        this.maintenanceHistoryGridOptions = {
            multiSelect:false,
            columnDefs:[{field:'whenPerformed',name:'When Performed',cellFilter:'date:\'yyyy-MM-dd\''},{field:'actionPerformed',name:'Action Performed'},{field:'performedBy',name:'Performed By'}],
            data:[],
        };
        this.gridOptions = {
            columnDefs:[{field:'name',name:'Name'},{field:'nextMaintenance',name:'Scheduled',cellFilter: 'date:\'yyyy-MM-dd\''}],
            data:[],
            multiSelect:false,
            onRegisterApi:function(gridApi:any) {
                gridApi.selection.on.rowSelectionChanged($scope,function(row:any) {
                    var entity = row.entity;
                    //alert("row selection changed. entity.name="+entity.name+". is selected="+row.isSelected);
                    if (row.isSelected) {
                        $scope.vm.model.selectedAsset = entity;
                        $scope.vm.model.getMaintenanceHistories(entity.id).then((data:any)=>{
                            $scope.vm.maintenanceHistoryGridOptions.data = data;
                        });
                    }
                    else
                        $scope.vm.model.selectedAsset = null;
                });
            }
        };
        this.$scope.$watch(() => this.model.afterDate,(newValue: any, oldValue: any) => {
          if(newValue != oldValue) {
            this.getAssets();
          }
        });
        this.$scope.$watch(() => this.model.beforeDate,(newValue: any, oldValue: any) => {
          if(newValue != oldValue) {
            this.getAssets();
          }
        });
    }
    getAssets(){
        this.model.getAssets().then(()=>{
            this.gridOptions.data = this.model.assets;
        }).catch((exc)=>{
          this.notifyService.notifyError("Got error in getting maintenance histories:"+exc);
        });
    }
    save(){
        this.model.save().then(()=>{
            this.getAssets();
        })
        .catch((exc)=>{
            this.notifyService.notify("Got exc saving Maintenance History:"+exc);
        });
    }
}
